export default __webpack_public_path__ + "static/avatar-kayi-common-6-cover-3babb83f7de6f29dbc8a6b02e605b1a7.png";